/* ==========================================================================
   Pool Busters — Leak Detection (pb-ld-*)
   Loaded once, deferred, only on page.leak-detection. Exposes PB_LD.

   Rules this file keeps:
   - Nothing changes by itself. Tabs, steps and demonstrations change only on
     a person's click, tap or key. The only ambient motion (the hero seep)
     pauses off-screen and is off under reduced motion.
   - The live site binds a delegated click handler that calls preventDefault()
     on every anchor, so links inside .pbld navigate themselves.
   - position:fixed is relative to Debut's transformed page container, so the
     phone bar is lifted to <body> inside its own .pbld wrapper (the colour
     tokens live on .pbld).
   - The form submits natively to Shopify; a success message is shown only
     when Shopify renders it.
   ========================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- links navigate themselves ---------- */
  function onLink(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    var href = a.getAttribute('href');
    if (!href) return;
    if (href.charAt(0) === '#') {
      var t = href.length > 1 && document.getElementById(href.slice(1));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', href);
      return;
    }
    e.preventDefault();
    window.location.href = a.href;
  }

  /* ---------- a generic, accessible tablist ---------- */
  function tablist(list, onSelect) {
    var tabs = $$('[role="tab"]', list);
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.classList.toggle('is-active', on);
      });
      if (focus) tab.focus();
      if (onSelect) onSelect(tab, tabs.indexOf(tab));
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = null, n = tabs.length;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + n) % n;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = n - 1;
        if (j === null) return;
        e.preventDefault();
        select(tabs[j], true);
      });
    });
    return { tabs: tabs, select: select };
  }

  /* ---------- hero: pause the seep when it can't be seen ---------- */
  function initHero() {
    var hero = $('.pbld-hero');
    if (!hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { hero.classList.toggle('is-paused', !en[0].isIntersecting); }).observe(hero);
  }

  /* ---------- sub-nav: mark the section in view ---------- */
  function initSubnav() {
    var nav = $('[data-pbld-subnav]');
    if (!nav || !('IntersectionObserver' in window)) return;
    /* the floating copy: fixed, so it lives on <body> inside its own .pbld */
    var host = document.createElement('div');
    host.className = 'pbld pbld-subnav-host';
    var float = nav.cloneNode(true);
    float.removeAttribute('data-pbld-subnav');
    float.setAttribute('aria-label', 'On this page (pinned)');
    float.setAttribute('aria-hidden', 'true');
    $$('a', float).forEach(function (a) { a.tabIndex = -1; });
    host.appendChild(float);
    document.body.appendChild(host);
    host.addEventListener('click', onLink);
    /* A passive scroll check, not an IntersectionObserver: a jump link from the
       hero carries the page straight past the nav without it ever intersecting,
       and an observer only reports changes, so the pinned copy never appeared. */
    var shown = null, ticking = false;
    function place() {
      ticking = false;
      var past = nav.getBoundingClientRect().bottom < 0;
      if (past === shown) return;
      shown = past;
      float.classList.toggle('is-shown', past);
      float.setAttribute('aria-hidden', String(!past));
      $$('a', float).forEach(function (a) { a.tabIndex = past ? 0 : -1; });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true });
    place();

    var navs = [nav, float];
    var map = {};
    $$('a[href^="#"]', nav).forEach(function (a) {
      if (a.classList.contains('pbld-subnav__cta')) return;
      var id = a.getAttribute('href').slice(1);
      if (document.getElementById(id)) map[id] = true;
    });
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        navs.forEach(function (n) {
          $$('a', n).forEach(function (a) {
            var on = a.getAttribute('href') === '#' + x.target.id;
            a.classList.toggle('is-current', on);
            if (on && n === float) {
              var box = a.parentNode, l = a.offsetLeft - 24;
              if (l < box.scrollLeft || a.offsetLeft + a.offsetWidth > box.scrollLeft + box.clientWidth) box.scrollTo({ left: l, behavior: 'auto' });
            }
          });
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  /* ---------- phone action bar ---------- */
  function initBar() {
    var bar = $('[data-pbld-sticky]');
    if (!bar) return;
    var host = document.createElement('div');
    host.className = 'pbld pbld-bar-host';
    host.appendChild(bar);
    document.body.appendChild(host);
    document.body.classList.add('pbld-has-bar');
    host.addEventListener('click', onLink);
    /* hidden while the hero's own buttons or the request form are on screen,
       so the same two actions never appear twice */
    var targets = [$('.pbld-hero .pbld-actions'), $(bar.getAttribute('data-hide-when'))].filter(Boolean);
    if (targets.length && 'IntersectionObserver' in window) {
      var seen = targets.map(function () { return false; });
      bar.classList.add('is-away');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { seen[targets.indexOf(x.target)] = x.isIntersecting; });
        bar.classList.toggle('is-away', seen.indexOf(true) !== -1);
      }, { threshold: 0.02 });
      targets.forEach(function (t) { io.observe(t); });
    }
  }

  /* ---------- 2. leak or evaporation ---------- */
  function initScenarios() {
    var root = $('[data-pbld-scen]');
    if (!root) return;
    var fig = $('[data-scen-fig]', root);
    tablist($('[role="tablist"]', root), function (tab) { fig.setAttribute('data-scen-fig', tab.getAttribute('data-scen')); });
  }

  /* ---------- 3. bucket test ---------- */
  function initBucket() {
    var root = $('[data-pbld-bucket]');
    if (!root) return;
    var prev = $('[data-step-prev]', root), next = $('[data-step-next]', root);
    var tl = tablist($('.pbld-bk__nav', root), function (tab, i) {
      root.setAttribute('data-step', String(i + 1));
      tl && tl.tabs.forEach(function (t, j) { t.classList.toggle('is-past', j < i); });
      prev.disabled = i === 0;
      next.disabled = i === 4;
      next.textContent = i === 4 ? 'Last step' : 'Next step';
    });
    root.setAttribute('data-result', 'same');
    function go(d) {
      var i = Number(root.getAttribute('data-step')) - 1 + d;
      if (i >= 0 && i < tl.tabs.length) tl.select(tl.tabs[i], false);
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    $$('[data-result]', root).forEach(function (b) {
      if (b === root) return;
      b.addEventListener('click', function () {
        var r = b.getAttribute('data-result');
        root.setAttribute('data-result', r);
        $$('button[data-result]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        $$('[data-res]', root).forEach(function (p) { p.hidden = p.getAttribute('data-res') !== r; });
      });
    });
  }

  /* ---------- 3. water-loss calculator ---------- */
  var calcState = null;
  function num(v) {
    if (v == null) return NaN;
    v = String(v).trim().replace(',', '.');
    if (!/^\d*\.?\d+$/.test(v)) return NaN;
    return parseFloat(v);
  }
  function fmt(n, d) { return n.toLocaleString('en-CA', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
  function litres(n) { return n >= 100 ? Math.round(n / 10) * 10 : Math.round(n); }
  function initCalc() {
    var root = $('[data-pbld-calc]');
    if (!root) return;
    var shape = $('#pbld-shape', root), len = $('#pbld-len', root), wid = $('#pbld-wid', root), area = $('#pbld-area', root);
    var pd = $('#pbld-pdrop', root), bd = $('#pbld-bdrop', root);
    var err = $('[data-calc-err]', root), empty = $('[data-calc-empty]', root), res = $('[data-calc-res]', root);
    function units() { var c = $('input[name="pbld-units"]:checked', root); return c ? c.value : 'metric'; }
    function o(k) { return $('[data-o="' + k + '"]', root); }
    function labels() {
      var imp = units() === 'imperial';
      $$('[data-u="len"]', root).forEach(function (s) { s.textContent = imp ? '(ft)' : '(m)'; });
      $$('[data-u="area"]', root).forEach(function (s) { s.textContent = imp ? '(sq ft)' : '(m²)'; });
      $$('[data-u="drop"]', root).forEach(function (s) { s.textContent = imp ? '(in)' : '(mm)'; });
      var tip = $('[data-u="tip"]', root);
      if (tip) tip.textContent = imp ? 'Over the same 24 hours. Use decimals for fractions of an inch, for example 0.25.' : 'Over the same 24 hours, in millimetres.';
      var s = shape.value;
      $('[data-dims]', root).hidden = s === 'area';
      $('[data-area]', root).hidden = s !== 'area';
      $$('[data-hint]', root).forEach(function (h) { h.hidden = h.getAttribute('data-hint') !== s; });
    }
    function show(state) {
      calcState = state;
      empty.hidden = !!state;
      res.hidden = !state;
      $('[data-calc-sent]', root).hidden = true;
    }
    function run() {
      labels();
      err.hidden = true;
      var imp = units() === 'imperial', s = shape.value;
      var L = num(len.value), W = num(wid.value), A = num(area.value), P = num(pd.value), B = num(bd.value);
      var haveSize = s === 'area' ? !isNaN(A) : (!isNaN(L) && !isNaN(W));
      var typed = [len, wid, area, pd, bd].some(function (i) { return i.value.trim() !== ''; });
      var bad = [len, wid, area, pd, bd].filter(function (i) { return i.value.trim() !== '' && isNaN(num(i.value)); });
      if (bad.length) { err.textContent = 'Use numbers only, for example 9.5 or 0.25.'; err.hidden = false; show(null); return; }
      if (!haveSize || isNaN(P) || isNaN(B)) { show(null); return; }
      var m2 = s === 'area' ? (imp ? A * 0.09290304 : A) : (imp ? L * 0.3048 * W * 0.3048 : L * W);
      if (s === 'oval') m2 = m2 * Math.PI / 4;
      var pmm = imp ? P * 25.4 : P, bmm = imp ? B * 25.4 : B;
      if (m2 <= 0 || m2 > 2000) { err.textContent = 'That surface area looks unusual. Please check the pool size and units.'; err.hidden = false; show(null); return; }
      if (pmm > 300 || bmm > 300) { err.textContent = 'Those drops are very large for 24 hours. Please check the units: millimetres or inches.'; err.hidden = false; show(null); return; }
      var diff = pmm - bmm;
      var lday = Math.max(0, m2 * diff);
      var tone, verdict;
      if (diff < -3) { tone = 'check'; verdict = 'The bucket dropped more than the pool. That usually means the test needs repeating: splashing, rain or the bucket’s position can all affect it.'; }
      else if (diff <= 3) { tone = 'same'; verdict = 'The pool and the bucket dropped by about the same amount, so evaporation is the likely explanation.'; }
      else { tone = 'more'; verdict = 'The pool dropped noticeably more than the bucket, so an actual leak may be present. A professional investigation can identify or narrow down the source.'; }
      o('lday').textContent = fmt(litres(lday));
      o('lweek').textContent = fmt(litres(lday * 7));
      o('area').textContent = imp ? fmt(m2 / 0.09290304, 0) + ' sq ft' : fmt(m2, 1) + ' m²';
      o('areakind').textContent = s === 'rect' ? 'from your size' : (s === 'oval' ? 'estimate' : 'your figure');
      o('pdrop').textContent = imp ? fmt(P, 2) + ' in' : fmt(P, 0) + ' mm';
      o('bdrop').textContent = imp ? fmt(B, 2) + ' in' : fmt(B, 0) + ' mm';
      o('diff').textContent = imp ? fmt(diff / 25.4, 2) + ' in' : fmt(diff, 0) + ' mm';
      var v = o('verdict'); v.textContent = verdict; v.setAttribute('data-tone', tone);
      show({
        lday: litres(lday), imp: imp, shape: s,
        size: s === 'area' ? (imp ? fmt(A, 0) + ' sq ft' : fmt(A, 1) + ' m²') : fmt(L, 1) + ' x ' + fmt(W, 1) + (imp ? ' ft' : ' m') + (s === 'oval' ? ' oval' : ''),
        p: imp ? fmt(P, 2) + ' in' : fmt(P, 0) + ' mm', b: imp ? fmt(B, 2) + ' in' : fmt(B, 0) + ' mm'
      });
      void typed;
    }
    root.addEventListener('input', run);
    root.addEventListener('change', run);
    labels();

    /* carry the result into the request form, only when the person asks */
    $('[data-calc-send]', root).addEventListener('click', function () {
      if (!calcState) return;
      var f = $('#pbld-form');
      if (!f) return;
      var c = calcState;
      var summary = c.lday + ' L/day unexplained (calculator estimate). Size ' + c.size + '; pool dropped ' + c.p + ', bucket dropped ' + c.b + ' in 24 h.';
      var hid = $('[data-calc-field]', f); if (hid) hid.value = summary;
      var loss = $('[data-calc-loss]', f);
      if (loss && (!loss.value.trim() || loss.getAttribute('data-from-calc') === '1')) { loss.value = 'About ' + c.lday + ' litres a day unexplained (calculator estimate)'; loss.setAttribute('data-from-calc', '1'); }
      var dims = $('[data-calc-dims]', f);
      if (dims && (!dims.value.trim() || dims.getAttribute('data-from-calc') === '1')) { dims.value = c.size; dims.setAttribute('data-from-calc', '1'); }
      var yes = $('[data-bucket-yes]', f); if (yes) { yes.checked = true; yes.dispatchEvent(new Event('change', { bubbles: true })); }
      var p = $('[data-calc-p]', f); if (p && (!p.value.trim() || p.getAttribute('data-from-calc') === '1')) { p.value = c.p; p.setAttribute('data-from-calc', '1'); }
      var b = $('[data-calc-b]', f); if (b && (!b.value.trim() || b.getAttribute('data-from-calc') === '1')) { b.value = c.b; b.setAttribute('data-from-calc', '1'); }
      var note = $('[data-calc-note]', f);
      if (note) { note.hidden = false; $('[data-calc-summary]', note).textContent = summary; }
      $('[data-calc-sent]', root).hidden = false;
    });
  }

  /* ---------- 1. hero: explore possible leak points ----------
     A numbered marker and its tab are one control. Liner is selected at load;
     after that it changes only when a person picks a marker or a tab. */
  function initHeroPoints() {
    var root = $('[data-pbld-points]');
    if (!root) return;
    var pts = $$('.pbld-pt', root);
    var tl = tablist($('.pbld-hero__tabs', root), function (tab) {
      var k = tab.getAttribute('data-point');
      root.setAttribute('data-focus', k);
      pts.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-point') === k); });
    });
    pts.forEach(function (p) {
      p.classList.toggle('is-on', p.getAttribute('data-point') === root.getAttribute('data-focus'));
      p.addEventListener('click', function () {
        var t = tl.tabs.filter(function (x) { return x.getAttribute('data-point') === p.getAttribute('data-point'); })[0];
        if (t) tl.select(t, false);
      });
    });
    /* "Explore leak sources" opens the full section on the same category;
       the jump itself is handled by onLink */
    $$('[data-anat]', root).forEach(function (a) {
      a.addEventListener('click', function () { if (anatSelect) anatSelect(a.getAttribute('data-anat')); });
    });
  }

  /* ---------- 4. where pools leak ---------- */
  var anatSelect = null;
  function initAnatomy() {
    var root = $('[data-pbld-anat]');
    if (!root) return;
    var hots = $$('.pbld-hot', root);
    var tl = tablist($('[role="tablist"]', root), function (tab) {
      var k = tab.getAttribute('data-focus-to');
      root.setAttribute('data-focus', k);
      hots.forEach(function (h) { h.classList.toggle('is-on', h.getAttribute('data-focus-to') === k); });
    });
    hots.forEach(function (h) {
      h.addEventListener('click', function () {
        var k = h.getAttribute('data-focus-to');
        var t = tl.tabs.filter(function (x) { return x.getAttribute('data-focus-to') === k; })[0];
        if (t) tl.select(t, false);
      });
    });
    hots.forEach(function (h) { h.classList.toggle('is-on', h.getAttribute('data-focus-to') === root.getAttribute('data-focus')); });
    anatSelect = function (k) {
      var t = tl.tabs.filter(function (x) { return x.getAttribute('data-focus-to') === k; })[0];
      if (t) tl.select(t, false);
    };
  }

  /* ---------- 5. technology tabs + demonstrations ---------- */
  function initTech() {
    $$('[data-pbld-tabs]').forEach(function (root) { tablist($('[role="tablist"]', root)); });
    $$('[data-pbld-demo]').forEach(function (demo) {
      var btn = $('[data-demo-run]', demo), timer = null;
      function finish() {
        clearTimeout(timer);
        demo.classList.remove('is-running');
        demo.classList.add('is-done');
        btn.textContent = 'Run it again';
      }
      function run() {
        clearTimeout(timer);
        demo.classList.remove('is-running', 'is-done');
        void demo.getBoundingClientRect();
        if (reduce) { finish(); return; }
        demo.classList.add('is-running');
        timer = setTimeout(finish, 6400);
      }
      btn.addEventListener('click', run);
      $$('[data-outcome-to]', demo).forEach(function (b) {
        b.addEventListener('click', function () {
          demo.setAttribute('data-outcome', b.getAttribute('data-outcome-to'));
          $$('[data-outcome-to]', demo).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          run();
        });
      });
    });
  }

  /* ---------- 10. request form ---------- */
  function fieldOf(i) { return i.closest('.pbld-f'); }
  function check(i) {
    var v = (i.value || '').trim(), bad = false;
    if (i.required && !v) bad = true;
    else if (i.type === 'email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) bad = true;
    else if (i.type === 'tel' && v && v.replace(/\D/g, '').length < 7) bad = true;
    var f = fieldOf(i), m = f && $('.pbld-f__msg', f);
    i.setAttribute('aria-invalid', String(bad));
    if (m) {
      if (!m.id) m.id = i.id + '-msg';
      if (bad) i.setAttribute('aria-describedby', m.id); else i.removeAttribute('aria-describedby');
      m.hidden = !bad;
    }
    return !bad;
  }
  function tempNote(v) {
    var m = String(v || '').toLowerCase().match(/(-?\d+(?:[.,]\d+)?)\s*°?\s*([cf])?/);
    if (!m) return false;
    var n = parseFloat(m[1].replace(',', '.')), u = m[2] || (n <= 40 ? 'c' : 'f');
    return u === 'c' ? n < 21 : n < 70;
  }
  function initForm() {
    var form = $('#pbld-form');
    if (!form) return;
    if (form.tagName !== 'FORM') form = $('form', form) || form;
    var sent = $('[data-pbld-sent]');
    if (sent) { sent.scrollIntoView({ block: 'center' }); sent.focus({ preventScroll: true }); return; }
    function sync() {
      var yes = $('[data-bucket-yes]', form);
      $('[data-bucket-detail]', form).hidden = !(yes && yes.checked);
      var pt = $('#pbld-ptype', form).value;
      $('[data-ptype-note]', form).hidden = !pt || /vinyl/i.test(pt);
      $('[data-temp-note]', form).hidden = !tempNote($('[data-temp]', form).value);
      var cn = $('[data-clear-no]', form);
      $('[data-clear-note]', form).hidden = !(cn && cn.checked);
      var ph = $('[data-photos]', form);
      $('[data-photos-note]', form).hidden = !(ph && ph.checked);
    }
    form.addEventListener('change', sync);
    form.addEventListener('input', function (e) {
      if (e.target.matches('[data-temp]')) sync();
      if (e.target.hasAttribute('data-from-calc')) e.target.removeAttribute('data-from-calc');
      /* clear an error while typing, never on blur: a message collapsing on
         blur moves the button out from under a click already in progress */
      if (e.target.getAttribute('aria-invalid') === 'true') {
        var i = e.target, v = i.value.trim();
        var ok = v && !(i.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) && !(i.type === 'tel' && v.replace(/\D/g, '').length < 7);
        if (ok) check(i);
      }
    });
    var rm = $('[data-calc-remove]', form);
    /* Remove takes back everything the calculator wrote, except fields the
       person has since edited themselves */
    if (rm) rm.addEventListener('click', function () {
      $('[data-calc-field]', form).value = '';
      $$('[data-from-calc="1"]', form).forEach(function (i) { i.value = ''; i.removeAttribute('data-from-calc'); });
      $('[data-calc-note]', form).hidden = true;
    });
    form.addEventListener('submit', function (e) {
      var first = null;
      $$('input[required], select[required], textarea[required]', form).forEach(function (i) { if (!check(i) && !first) first = i; });
      if (first) {
        e.preventDefault();
        first.focus({ preventScroll: true });
        first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var b = $('button[type="submit"]', form);
      if (b) { b.disabled = true; b.textContent = 'Sending…'; }
    });
    /* re-enable if the page is restored from the back-forward cache */
    window.addEventListener('pageshow', function () { var b = $('button[type="submit"]', form); if (b) { b.disabled = false; b.textContent = 'Send my leak detection request'; } });
    sync();
  }

  function init() {
    $$('.pbld').forEach(function (r) { if (!r.classList.contains('pbld-bar-host')) r.addEventListener('click', onLink); });
    initHero();
    initSubnav();
    initBar();
    initScenarios();
    initBucket();
    initCalc();
    initAnatomy();
    initHeroPoints();
    initTech();
    initForm();
  }
  window.PB_LD = { version: '1.0.0' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
